export type ChipWeights = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export enum ChipSelectionOrigin {
  User = 'User',
  System = 'System',
  PlayerConfig = 'PlayerConfig',
}

export interface ChipValueType {
  value: number;
  weight: ChipWeights;
  selectedBy?: ChipSelectionOrigin;
}
